import { render, staticRenderFns } from "./SelectDialog.vue?vue&type=template&id=2504ad0b&"
import script from "./SelectDialog.vue?vue&type=script&lang=js&"
export * from "./SelectDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports